function setCookieWithResidueTime(name, value, cookieResidueTime) {
  const expires = new Date();
  expires.setTime(expires.getTime() + cookieResidueTime); // 设置过期时间为当前时间 + 剩余时间
  document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`;
}
function getCookie(name) {
  const cookieArr = document.cookie.split(";"); // 分隔出每个 cookie

  for (let cookie of cookieArr) {
    cookie = cookie.trim(); // 去除多余的空格
    if (cookie.startsWith(name + "=")) {
      return cookie.substring(name.length + 1); // 返回 cookie 的值
    }
  }
  return null; // 如果未找到指定的 cookie，则返回 null
}

//删除cookie
function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1); //将date设置为过去的时间
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

export { setCookieWithResidueTime, getCookie, delCookie };
